import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { PostHogProvider } from "posthog-js/react";
import "cal-sans";
import "./i18n";
import "./index.css";
import App from "./App";

const posthogOptions = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
};

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#111827" },
    secondary: { main: "#6b7280" },
    background: { default: "#ffffff", paper: "#ffffff" },
    text: { primary: "#111827", secondary: "#6b7280", disabled: "#9ca3af" },
    divider: "#e5e7eb",
  },
  typography: {
    fontFamily: '"Cal Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontFamily: '"Cal Sans", "Inter", sans-serif', letterSpacing: "-0.02em" },
    h2: { fontFamily: '"Cal Sans", "Inter", sans-serif', letterSpacing: "0.01em" },
    h3: { fontFamily: '"Cal Sans", "Inter", sans-serif', letterSpacing: "0.015em" },
    h4: { fontFamily: '"Cal Sans", "Inter", sans-serif', letterSpacing: "0.02em" },
    h5: { fontFamily: '"Cal Sans", "Inter", sans-serif', letterSpacing: "0.03em" },
    h6: { fontFamily: '"Cal Sans", "Inter", sans-serif', letterSpacing: "0.04em" },
  },
  shape: { borderRadius: 4 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { boxShadow: "none", border: "1px solid #e5e7eb", borderRadius: 4 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 4, textTransform: "none", fontWeight: 500 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { boxShadow: "none", border: "1px solid #e5e7eb", borderRadius: 4 },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={posthogOptions}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </PostHogProvider>
  </React.StrictMode>
);
